
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gps",
      function () {
        return require("private-next-pages/gps/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gps"])
      });
    }
  